import React from 'react';
import { post } from '../../api/baseUrl';
import { useGlobalLoading } from '../../context/LoadingContext';
import { useLoggedInUser } from '../../context/LoggedInUserContext';
import type { RootState } from '../../store';
import { useSelector } from 'react-redux';

export const useAssignPatient = () => {
  const { startLoading, stopLoading } = useGlobalLoading();
  const [loading, setLoading] = React.useState(false);
  const { loggedInUser } = useLoggedInUser();
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );

  const setFavourite = async (
    favourited: boolean,
    patientAccessToken: string,
    triggerUpdate?: () => void,
  ) => {
    try {
      setLoading(true);

      if (!selectedTenancy?.tenancy_id) return;

      const {
        data: { data },
      } = await post(`setFavourite`, {
        favourited,
        access_token: patientAccessToken,
        tenancyId: selectedTenancy.tenancy_id,
      });
      if (triggerUpdate) {
        triggerUpdate();
      }
      return data;
    } catch (error: any) {
      console.error(error);
      throw new Error('Failed to set favourite', error.messag);
    } finally {
      setLoading(false);
    }
  };

  const assignToClinician = async (
    isAssigned: boolean,
    patientAccessToken: string,
    clinicianId?: number,
    triggerPatientListUpdate?: () => void,
  ) => {
    let clinician = clinicianId;
    if (!clinician && loggedInUser) {
      clinician = loggedInUser.userId;
    }
    try {
      startLoading();
      if (!selectedTenancy?.tenancy_id) return;
      const {
        data: { data },
      } = await post(`setFavourite`, {
        assignToClinician: { clinicianId: clinician, isAssigned },
        access_token: patientAccessToken,
        tenancyId: selectedTenancy.tenancy_id,
      });
      if (triggerPatientListUpdate) {
        triggerPatientListUpdate();
      }
      return data;
    } catch (error: any) {
      console.error(error);
      throw new Error('Failed to assignToClinician', error.message);
    } finally {
      stopLoading();
    }
  };

  return { setFavourite, assignToClinician, loading };
};
